import script from "./supplement-list.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-list.vue?vue&type=script&setup=true&lang=js"

import "./supplement-list.vue?vue&type=style&index=0&id=4eca21fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eca21fa"]])

export default __exports__